import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { formatDate, toQueryParams } from 'admin/utils';
import {
  testRunSoftwareRelease,
  clearSoftwareRelease,
} from 'admin/actions/software-releases';
import { clearAPIError } from 'admin/actions/api-error';
import FilterSelect from 'admin/components/pages/CreateSoftwareRelease/FilterSelect';


const Table = styled.table`
  margin: 20px 0;
  margin-top: 20px;
  width: 100%;
  tbody {
    td {
      text-align: left;
      padding: 10px 0;
      border-bottom: 1px solid #EEE;
    }
    td:first-child {
      font-weight: bold;
    }
    tr:last-child {
      td { border: none; }
    }
  }
`;

class TestRunModalBody extends Component {

  componentWillMount() {
    this.props.clearSoftwareRelease();
    this.props.clearAPIError();
  }

  renderSoftwareRelease() {
    const rel = this.props.softwareRelease;
    if (!rel.id) return null;
    const {
      id, software, description, created_at,
    } = rel;
    return (
      <div>
        <strong>対象ターミナルの最新リリース</strong>
        <Table>
          <tbody>
            <tr>
              <td>バージョンコード</td>
              <td>
                <a href={`/service-settings/software-release/${id}`}>
                  { software.version_code }
                </a>
              </td>
            </tr>
            <tr>
              <td>リリースの説明</td>
              <td>{ description }</td>
            </tr>
            <tr>
              <td>登録日時</td>
              <td>{ formatDate(created_at) }</td>
            </tr>
          </tbody>
        </Table>
      </div>
    );
  }

  renderAPIError() {
    const { apiError } = this.props;
    if (!apiError) return null;
    return (
      <div><strong>{apiError.message}</strong></div>
    );
  }

  render() {
    return (
      <div>
        <strong>ターミナルを選択して下さい</strong>
        <FilterSelect
          target="terminal"
          onSelectTerminal={(uuid) => {
            const params = toQueryParams({
              terminalUuid: uuid,
              productCode: this.props.productCode,
              targetHardware: this.props.targetHardware,
            }, true);
            this.props.testRunSoftwareRelease(params);
          }}
        />
        { this.renderSoftwareRelease() }
        { this.renderAPIError() }
      </div>
    );
  }
}

TestRunModalBody.defaultProps = {
  softwareRelease: {},
  apiError: null,
};

const mapStateToProps = state => ({
  softwareRelease: state.softwareRelease.softwareRelease,
  apiError: state.apiError.error,
});

TestRunModalBody.propTypes = {
  productCode: PropTypes.string.isRequired,
  targetHardware: PropTypes.string.isRequired,
  testRunSoftwareRelease: PropTypes.func.isRequired,
  clearSoftwareRelease: PropTypes.func.isRequired,
  clearAPIError: PropTypes.func.isRequired,
  softwareRelease: PropTypes.object,
  apiError: PropTypes.object,
};

const mapDispatchToProps = dispatch => bindActionCreators({
  testRunSoftwareRelease,
  clearSoftwareRelease,
  clearAPIError,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(TestRunModalBody);
